import { throttle } from './utils';
export class DomEvent {
    constructor() {
        this.scollerEl = document.scrollingElement || document.documentElement || document.body;
        this.bottomEvents = [];
        this.bottom = createListener(this, this.bottomEvents);
        window.addEventListener('scroll', throttle(() => {
            const { scrollHeight, scrollTop } = this.scollerEl;
            const height = window.screen.availHeight;
            if (scrollHeight - scrollTop - height < 300) {
                // console.log('bottom')
                this.bottomEvents.forEach((cb) => {
                    var _a;
                    (_a = cb) === null || _a === void 0 ? void 0 : _a();
                });
            }
        }, 50));
    }
}
export function createListener(ctx, events) {
    return {
        on: function (cb) {
            if (events.indexOf(cb) <= -1) {
                events.push(cb);
            }
        }.bind(ctx),
        off: function (cb) {
            return events.remove(cb);
        }.bind(ctx),
    };
}
export const domEvent = new DomEvent();
